import { changePasswordSchema } from '@mm/shared';
import { api, type SessionPayload } from '../../api/client';
import { Button } from '../../components/ui/Button';
import { Card, DetailList, PageHeader, StatusBadge } from '../../components/ui/display';
import { useToast } from '../../components/ui/Toast';
import { type FieldDef, ResourceForm } from '../../forms/ResourceForm';
import { useAuth } from './AuthProvider';
import { SecuritySettings } from './SecuritySettings';

const fields: FieldDef[] = [
  {
    name: 'currentPassword',
    label: 'Current password',
    type: 'password',
    required: true,
    wide: true,
  },
  {
    name: 'newPassword',
    label: 'New password',
    type: 'password',
    required: true,
    wide: true,
    help: 'At least 10 characters',
  },
];

export function ProfilePage() {
  const { user, applySession } = useAuth();
  const toast = useToast();
  if (!user) return null;

  return (
    <>
      <PageHeader title="Your account & security" />
      <div className="grid max-w-3xl gap-6">
        <Card title="Profile">
          <DetailList
            items={[
              { label: 'Name', value: user.name },
              { label: 'Email', value: user.email },
              { label: 'Role', value: <StatusBadge status={user.role} /> },
            ]}
          />
        </Card>
        <SecuritySettings />
        <Card title="Change password" description="You will be signed out on other devices.">
          <div className="max-w-sm">
            <ResourceForm
              formId="change-password"
              fields={fields}
              schema={changePasswordSchema}
              defaultValues={{ currentPassword: '', newPassword: '' }}
              isEdit={false}
              lookups={undefined}
              onSubmit={async (values) => {
                const session = await api.post<SessionPayload>('/auth/change-password', values);
                applySession(session);
                toast.success('Password changed');
              }}
            />
            <Button type="submit" form="change-password" className="mt-4">
              Change password
            </Button>
          </div>
        </Card>
      </div>
    </>
  );
}
